<template>
  <div id="wrapper">
    <div class="normalheader" v-if="!$user.isBasic()">
      <div class="hpanel">
        <div class="panel-body">
          <div id="hbreadcrumb" class="pull-right m-t-lg">
            <ol class="hbreadcrumb breadcrumb" v-if="project">
              <li><router-link :to="{name: 'Dashboard'}">Dashboard</router-link></li>
              <li><router-link :to="{name: 'Projects'}">Projects</router-link></li>
              <li><router-link :to="{name: 'ProjectDetails', params: {id: project.id}}">Project Overview</router-link></li>
              <li class="active">
                <span>Explore</span>
              </li>
            </ol>
          </div>
          <h3 class="font-light m-b-xs" v-if="project">
            Explore - <router-link class="font-bold text-info" :to="{name: 'ProjectDetails', params: {id: project.id}}">{{project.name}}</router-link>
          </h3>
          <small>Analyse global scientific and technological landscapes.</small>
        </div>
      </div>
    </div>

    <div v-else class="normalheader">
      <div class="hpanel">
        <div class="panel-body">
          <div id="hbreadcrumb" class="pull-right m-t-lg">
            <ol class="hbreadcrumb breadcrumb">
              <li><router-link :to="{name: 'Dashboard'}">Dashboard</router-link></li>
              <li class="active">
                <span v-if="!$user.isFreeTrial()">Simple Search</span>
                <span v-else>DEMO page</span>
              </li>
            </ol>
          </div>
          <h3 class="font-light m-b-xs">
            <template v-if="!$user.isFreeTrial()">Simple Search</template>
            <template v-else>DEMO page</template>
          </h3>
          <template v-if="$user.isSe()"><small>Welcome to the LEA platform - the Schneider Electric tool dedicated to Open Innovation</small></template>
          <template v-else-if="$user.isFreeTrial()"><small>This is a demo page. To access the complete results, <a href="/user/register" target="_blank">subscribe to a free account.</a></small></template>
          <template v-else><small>Investigate global scientific and technological landscapes, find internal and external experts.</small></template>

        </div>
      </div>

    </div>

    <div class="content">
      <div class="row" id="project-summary" v-if="!$user.isBasic() && project">
        <project-box :project="project" :listIdSelected.sync="listIdSelected"
                     :authorsSimilar="authorsSimilar" :authorsSelected="authorsSelected"
                     :companiesSimilar="companiesSimilar" :companiesSelected="companiesSelected"/>
      </div>

      <div class="row">
        <div class="col-xs-12" style="min-height: 160px" id="wrapper-search-box">
          <search-box v-model="searchResult" @searchStateUpdate="searchStateUpdate"
                      @listTypeUpdate="listTypeUpdate" @searchTypeUpdate="searchTypeUpdate" @queryUpdate="queryUpdate"
                      @searchCountriesUpdate="searchCountriesUpdate" @nbSearchCompaniesUpdate="nbSearchCompaniesUpdate"
                      @errorQuotaUpdate="errorQuotaUpdate" :showLimitPlan="showLimitPlan"/>
        </div>
      </div>

      <div class="row" v-if="!($user.isBasic() && !query)">
        <div v-if="listType !== 'aichat'" class="col-xs-12">
          <stats-box :searchState="searchState" :pubDate="pubDate" :countries="countries" :suggestions="searchResult.suggestions"
                     :biblio="biblio" :listType="listType" :companies="companies" :showLimitPlan="showLimitPlan"></stats-box>
        </div>
      </div>
      <div class="row" v-if="!($user.isBasic() && !query) && ($user.isGAC() || $user.isIdexlab())">
        <div class="col-xs-12">
          <AiChatManagerBox v-if="query && (listType === 'author' || listType === 'patents')" :listIdSelected="listIdSelected" :searchResult="searchResult" :biblio="biblio" :listType="listType" :query="query" ></AiChatManagerBox> <!-- :result="items" :biblio="biblio" :context="context"--->
        </div>
      </div>

      <div class="row m-b-md"  v-if="!$user.isBasic()">
        <div class="col-xs-12" id="biblio" v-if="project">
          <biblio-box :listId="listIdSelected" :project="project" :height="340"></biblio-box>
        </div>
      </div>



      <template v-if="!query && $user.isBasic()">
        <welcome-static-box/>
      </template>
      <template v-else>
        <documents-box :searchResult="searchResult" :project="project" :searchState="searchState"
                       :similar="similar" :selected="selected" :listIdSelected="listIdSelected"
                       :listType="listType" :searchType="searchType" :searchCountries="searchCountries"
                       @updatePubDate="updatePubDate" @updateCountries="updateCountries"
                       :query="query" :nbSearchCompanies="nbSearchCompanies" :showLimitPlan="showLimitPlan"></documents-box>
      </template>
    </div>

    <limit-plan ref="limitPlan"></limit-plan>
  </div>

</template>

<style>

  #search-box.affix {
    top: 55px;
    z-index: 1000 !important;
    width: 100%;
  }

  @media (min-width: 768px) {
    #search-box.affix {
      right: 40px;
      padding-left: 260px;
    }

    .hide-sidebar #search-box.affix{
      right: 40px;
      padding-left: 80px;
    }
  }

  @media (max-width: 768px) {
    #search-box.affix {
      padding-right: 30px;
    }
  }

</style>

<script>

import SearchBox from './../../components/search/SearchBox'
import LimitPlan from '../../components/LimitPlan'
import ProjectBox from '../../components/project/ProjectBox'
import StatsBox from '../../components/search/StatsBox'
import BiblioBox from '../../components/biblio/BiblioBox'
import DocumentsBox from '../../components/search/DocumentsBox'
import WelcomeStaticBox from '../../components/simpleInterface/WelcomeStaticBox'
import AiChatManagerBox from '../../components/AiChatManagerBox/AiChatManagerBox';

export default {
  components: {
    WelcomeStaticBox,
    DocumentsBox,
    BiblioBox,
    StatsBox,
    LimitPlan,
    ProjectBox,
    SearchBox,
    AiChatManagerBox
  },
  name: 'Search',
  data () {
    return {
      searchResult: {
        authors: [],
        suggestions: [],
        totalNbResults: 0,
        nbResults: 0
      },
      project: null,
      searchState: 0,
      listType: 'author',
      searchType: null,
      searchCountries: [],
      query: null,
      nbSearchCompanies: null,
      authorsSimilar: [],
      authorsSelected: [],
      companiesSimilar: [],
      companiesSelected: [],
      similar: null,
      selected: null,
      listIdSelected: null,
      pubDate: [],
      countries: [],
      companies: [],
      biblio: null
    }
  },
  watch: {
    '$route' (to, from) {
      this.init()
    },
    listIdSelected: function (listId) {
      this.getLists()
    },
    searchState: function (newVal, oldVal) {
      if (newVal === 0 && oldVal === 2) {
        this.pubDate = []
        this.countries = []
        this.companies = []
      }
      if (newVal === 2) {
        this.$eventHub.$emit('startTour', true)
      }
    }
  },
  mounted () {
    if (!this.$user.isBasic()) {
      this.$eventHub.$on('updateCompanyAuthorList', (tmp) => {
        this.getLists()
      })

      this.$eventHub.$on('biblioSelected', (biblio) => {
        this.biblio = biblio
      })
    }

    let topAffix = this.$user.isBasic() ? 165 : 299

    $('#search-box').affix({
      offset: {
        top: topAffix,
        bottom: function () {
          return (this.bottom = $('.footer').outerHeight(true))
        }
      }
    })
  },
  methods: {
    init: function () {
      this.searchResult = {
        authors: [],
        suggestions: [],
        totalNbResults: 0,
        nbResults: 0
      }
      this.project = null
      this.searchState = 0
      this.listType = 'author'
      this.searchType = null
      this.searchCountries = []
      this.query = null

      let goal = (this.$route.query.goal) ? decodeURI(this.$route.query.goal) : null

      if (goal === 'topics' && !this.$user.isBasic()) {
        this.searchFromTopics().then(() => {
          this.getResources()
        })
      } else {
        this.getResources()
      }
    },
    getCompanyAuthors: function () {
      if (this.listIdSelected !== null) {
        this.axios.get('/list/' + this.listIdSelected + '?relations={companyAuthors}')
          .then((response) => {
            this.authorsSelected = response.data.company_authors.authors_selected
            this.authorsSimilar = response.data.company_authors.authors_similar
            this.companiesSelected = response.data.company_authors.companies_selected
            this.companiesSimilar = response.data.company_authors.companies_similar

            this.similar = Object.assign([], this.authorsSimilar, this.companiesSimilar)
            this.selected = Object.assign([], this.authorsSelected, this.companiesSelected)
          })
          .catch(() => {
          })
      }
    },
    getLists: function () {
      this.getCompanyAuthors()
    },
    getResources: function () {
      let projectId = parseInt(localStorage.getItem('projectSelected')) || null

      if (projectId !== null && !this.$user.isBasic()) {
        this.axios.get('/project/' + projectId + '?relations={portfolio,workflow,question,lists}')
          .then((response) => {
            this.project = response.data

            delete this.project.question
          }).catch((error) => {
          })
      }
    },
    searchStateUpdate: function (searchState) {
      this.searchState = searchState
    },
    listTypeUpdate: function (listType) {
      if (listType === 'science') {
        this.listType = 'author'
      } else {
        this.listType = listType
      }
    },
    searchTypeUpdate: function (searchType) {
      this.searchType = searchType
    },
    queryUpdate: function (query) {
      this.query = query
    },
    searchCountriesUpdate: function (countries) {
      this.searchCountries = countries
    },
    errorQuotaUpdate: function (errorQuota) {
      if (errorQuota === true) {
        this.$refs.limitPlan.show('quota')
      }
    },
    nbSearchCompaniesUpdate: function (nb) {
      this.nbSearchCompanies = nb
    },
    showLimitPlan: function (action) {
      this.$refs.limitPlan.show(action)
    },
    updatePubDate: function (val) {
      this.pubDate = val
    },
    updateCountries: function (val) {
      this.countries = val.countries
      this.companies = val.companies
    },
    searchFromTopics: function () {
      return new Promise((resolve, reject) => {
        let query = this.$route.params.query
        let data = {
          name: query,
          description: null,
          workflow_id: 1
        }
        this.axios.post('createFromTopics', data)
          .then((result) => {
            localStorage.setItem('projectSelected', result.data.id)
            localStorage.setItem('listIdSelected', result.data.lists[0].id)
            resolve(null)
          }).catch((error) => {
            this.$notify({
              type: 'danger',
              title: 'Project limit reached',
              content: 'Please delete projects to free up or increase space',
              placement: 'bottom-right',
              duration: 60000
            })
            this.$router.push({name: 'Projects'})
            reject(error)
          })
      })
    }
  },
  beforeMount () {
    this.init()
    if (this.$user.isBasic()) {
      localStorage.removeItem('projectSelected')
      localStorage.removeItem('listIdSelected')
    }
    if (this.$user.isFreeTrial()) {
      $('body').removeClass('hide-sidebar').addClass('hide-sidebar')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/search/Search.vue